import _ from "lodash";
import i18next from "i18next";

import {
  locales
} from "../../config/i18n";
import {
  formatDate,
  formatPrice
} from "./util";
import axios from "axios";

export const setUiLocale = (locale) => {
  if (!_.find(locales, supported => supported.code === locale)) {
    return Promise.reject(`Locale ${locale} is not supported.`);
  }

  return axios.get(`/static/translations/${locale}/common.json`)
    .then(loadedResources => (
      new Promise((resolve, reject) => {
        i18next.init({
          lng: locale,
          debug: false,
          resources: {
            [locale]: loadedResources.data
          },
          interpolation: {
            format(value, format, _locale) {
              if (value instanceof Date) {
                return formatDate(value, format, _locale);
              }

              if (_.startsWith(format, "style:currency")) {
                return formatPrice(value, format, _locale);
              }

              return value;
            }
          }
        }, (err) => {
          if (err) {
            reject(err);
            return;
          }

          resolve();
        });
      })
    ))
    .catch(err => Promise.reject(err));
};

export const t = (key, opt) => i18next.t(key, opt);

export const currentLocale = () => i18next.language
;
